export class EliminationCriteria {
  public eliminationCriteriaId: number;
  public referenceId: number;
  public bdMatrixEliminationCategoryId: number;
  public sectionType: number;
  public isSelected: boolean;
}
